import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './Commons/Layouts/App';
import store from './Commons/Store';
import './Commons/Extensions';
import './index.scss';
import './tailwind.css';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
